var scope_0 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0fcfa08f49b95ae6747f8280322313af.js').default;
var scope_1 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/136ab5fc7e926c5116988b9a9e93f4dc.js').default;
var scope_2 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_3 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/20fb1b397ed068194c14faf8b4c5cf8b.js').default;
var scope_4 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/285b8e53993fe3c86e6f4e82cb4dd82b.js').default;
var scope_5 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/46fa8e5d9e186ba2c1a751f8e7382770.js').default;
var scope_6 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/55a3665e85c392f1db5ca45bf490725d.js').default;
var scope_7 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5a6110c2b872e316d63adddac8ac3075.js').default;
var scope_8 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ceb3fd1a5e15f62d00eecb6ea7fd545.js').default;
var scope_9 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5db31bdc6ed2ad2a417a38953054b8b6.js').default;
var scope_10 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6756a4d4f4b6ecefbd633865ce146674.js').default;
var scope_11 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6bca9cf5fe9ef8a30282cc19f27a305b.js').default;
var scope_12 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/773baf28a043ca61cb009dc17f49e8c9.js').default;
var scope_13 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/80cccd0f23e445910e0620cf840adacc.js').default;
var scope_14 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/82a07ee63dda59dde87c8480e4d7c468.js').default;
var scope_15 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/85b4b4b2607dc5562be605fff5044bd1.js').default;
var scope_16 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ae04cd5a2a46df1dc11e7c4fdbf41b92.js').default;
var scope_17 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c17423f7caf069a36380ae51843b08ca.js').default;
var scope_18 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d6226d11b61b00389f5afd4b0717dbc3.js').default;
var scope_19 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/de0840d419c722f7d2ab88655d0f82d9.js').default;
var scope_20 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ef6fcb670396f03ea589bb39c2e8b194.js').default;
var scope_21 = require('/zeit/5c64f483/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f5bef37bb83a32925df37c5a67e7285b.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21 )
    